import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_star: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-star" {...rest}>
      <title>praise-star</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#F8AE41"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path
        fill="#FFF"
        d="M76.3 102.9l-33.1 17.4 6.3-36.9-26.7-26.1 37-5.3 16.5-33.6L92.9 52l36.9 5.3-26.7 26.1 6.3 36.9z"
      ></path>
      <path
        fill="#FFE98F"
        d="M76.3 93.2l-23.5 12.3 4.5-26.1-19-18.6L64.6 57l11.7-23.8L88.1 57l26.2 3.8-19 18.6 4.5 26.1z"
      ></path>
      <path
        fill="#FCD700"
        d="M76.3 82.8l-13.2 6.9L65.6 75 54.9 64.5l14.8-2.1L76.3 49l6.6 13.4 14.8 2.1L87 75l2.5 14.7z"
      ></path>
    </svg>
  );
};
